import request from '@/utils/request'


export function fechListUserByCard(data) {
  return request({
    url: '/admin/bycard/qlUserByCard',
    method: 'post',
    data: data
  })
}

//查询购买vip卡的用户
export function qlUserByCardChild(data) {
  return request({
    url: '/admin/bycard/qlUserByCardChild',
    method: 'post',
    data: data
  })
}
//扣课
export function deductCourse(data) {
  return request({
    url: '/admin/bycard/deductCourse',
    method: 'post',
    data: data
  })
}

//创建课程卡
export function createUserByCard(data) {
  return request({
    url: '/admin/bycard/newUserByCard',
    method: 'post',
    data: data
  })
}
//创建课程卡
export function clientShunt(data) {
  return request({
    url: '/admin/bycard/clientShunt',
    method: 'post',
    data: data
  })
}
//续课
export function renewalsRemaining(params) {
  return request({
    url: '/admin/bycard/renewalsRemaining',
    method: 'get',
    params: params
  })
}

//停卡
export function stopBuyCard(params) {
  return request({
    url: '/admin/bycard/stopBuyCard',
    method: 'get',
    params: params
  })
}

//重开卡
export function reStartBuyCard(params) {
  return request({
    url: '/admin/bycard/reStartBuyCard',
    method: 'get',
    params: params
  })
}
//调整卡
export function updateCardDetail(data) {
  return request({
    url: '/admin/bycard/updateCardDetail',
    method: 'post',
    data: data
  })
}
//续卡
export function renewalsCard(data) {
  return request({
    url: '/admin/bycard/renewalsCard',
    method: 'post',
    data: data
  })
}
//用户购买体验卡
export function newUserByExpCard(data) {
  return request({
    url: '/admin/bycard/newUserByExpCard',
    method: 'post',
    data: data
  })
}

//切换体验卡
export function changeUserExpCard(data) {
  return request({
    url: '/admin/bycard/changeUserExpCard',
    method: 'post',
    data:data
  })
}

//门店管理员续所有卡
export function extendAllVIPCardDay(params) {
  return request({
    url: '/admin/bycard/extendAllVIPCardDay',
    method: 'get',
    params: params
  })
}
//门店管理员续所有卡
export function getUserChildFollowDetailVoById(params) {
  return request({
    url: `/admin/bycard/getUserChildFollowDetailVoById/${params.userId}/${params.type}/${params.carId}`,
    method: 'get',
    // params: params
  })
}
//上传合同
export function addAgreement(data) {
  return request({
    url: '/admin/bycard/addAgreement',
    method:'post',
    data:data
  })
}

// 详情
export function qlUserByCardDetailVoById(params) {
  return request({
    url: `/admin/bycard/getUserBuyCardDetailVoById/${params.id}/${params.idt}`,
    method: 'get',
  })
}



// WEBPACK FOOTER //
// ./src/api/userByCard.js